// NOTE: We can reference this when writing up the RTL versions of our components:
//       https://www.w3.org/International/questions/qa-html-dir
export const isRightToLeftLocale = (locale: string): boolean => {
    // TODO: This is not an exhaustive list of RTL languages, but a placeholder for once we start supporting those locales
    switch (locale.toLocaleLowerCase()) {
        case 'ar':
        case 'he':
        case 'en-rtl':
            return true;
        default:
            return false;
    }
};
